'use strict';
 // Mobile filter sidebar toggler
const sidebar = document.querySelector(".podcast-filters");
const openFilterSidebarButton = document.getElementById("filter-mobile-toggle");
const filterWrapper = document.querySelector(".podcast-filter-wrapper");
const closeFilterSidebarButton = document.getElementById("close-filters");

// Function to open the filter sidebar
function openFilterSidebar() {
  filterWrapper.classList.add("is-active");
  openFilterSidebarButton.setAttribute("aria-expanded", "true");
}

// Function to close the filter sidebar
function closeFilterSidebar() {
  filterWrapper.classList.remove("is-active");
  openFilterSidebarButton.setAttribute("aria-expanded", "false");
  openFilterSidebarButton.focus();
}

// Event listener for opening the filter sidebar
openFilterSidebarButton.addEventListener("click", openFilterSidebar);

// Event listener for closing the filter sidebar using the close button
closeFilterSidebarButton.addEventListener("click", closeFilterSidebar);

// Close the filter sidebar when clicking outside of it
filterWrapper.addEventListener("click", (event) => {
  if (!sidebar.contains(event.target)) {
    closeFilterSidebar();
  }
});

// Close the filter sidebar when the ESC key is pressed
document.addEventListener("keydown", (event) => {
  if (event.key === "Escape") {
    closeFilterSidebar();
  }
});


// Get all checkboxes and div's
const categoryCheckboxes = document.querySelectorAll('input[name="category"]');
const speakerCheckboxes = document.querySelectorAll('input[name="speaker"]');
const durationCheckboxes = document.querySelectorAll('input[name="duration"]');
const dateCheckboxes = document.querySelectorAll('input[name="date"]');
const podcastItems = document.querySelectorAll(".podcast-card-link");
const noResultsMessage = document.querySelector(".no-results-message");
const feedbackContainer = document.querySelector(".feedback-container");

// Function to filter podcasts based on selected filters
function filterPodcasts() {
	// Get selected categories
	const selectedCategories = Array.from(categoryCheckboxes)
		.filter((checkbox) => checkbox.checked)
		.map((checkbox) => checkbox.value);

	// Get selected speakers
	const selectedSpeakers = Array.from(speakerCheckboxes)
		.filter((checkbox) => checkbox.checked)
		.map((checkbox) => checkbox.value);

	// Get selected durations
	const selectedDurations = Array.from(durationCheckboxes)
		.filter((checkbox) => checkbox.checked)
		.map((checkbox) => checkbox.value);

	// Get selected dates
	const selectedDates = Array.from(dateCheckboxes)
		.filter((checkbox) => checkbox.checked)
		.map((checkbox) => checkbox.value);

	let hasResults = false; // Track if any results are found

	// Loop through each podcast card
	podcastItems.forEach((item) => {
		const parentLi = item.closest("li");
		const category = item.getAttribute("data-category");
		const speaker = item.getAttribute("data-speaker");
		const durationStr = item.getAttribute("data-duration");
		const releaseDateStr = item.getAttribute("data-release-date");

		let duration = parseInt(durationStr);
		const releaseDate = new Date(releaseDateStr);

		// Check if the item matches the selected filters
		const matchesCategory = selectedCategories.length === 0 || selectedCategories.includes(category);
		const matchesSpeaker = selectedSpeakers.length === 0 || selectedSpeakers.includes(speaker);
		let matchesDuration = true;
		let matchesDate = true;  

		// Duration filtering
		if (selectedDurations.length > 0) {
			matchesDuration = selectedDurations.some((durationOption) => {
				if (durationOption === "0-30") {
					return duration <= 30;
				} else if (durationOption === "30-60") {
					return duration >= 30 && duration <= 60;
				} else if (durationOption === "over-60") {
					return duration > 60;
				}
				return false;  
			});
		}

		// Date filtering (allow multiple selections)
		if (selectedDates.length > 0) {
			matchesDate = selectedDates.some((dateOption) => {
				if (dateOption === "this-week") {
					return isWithinWeek(releaseDate);
				} else if (dateOption === "this-month") {
					return isWithinMonth(releaseDate);
				} else if (dateOption === "last-month") {
					return isWithinLastMonth(releaseDate);
				} else if (dateOption === "this-year") {
					return isWithinYear(releaseDate, new Date().getFullYear());
				} else if (dateOption === "last-year") {
					return isWithinYear(releaseDate, 2023);
				}
				return false; // If no match, return false
			});
		}

		// Display the item only if it matches all filters
		if (matchesCategory && matchesSpeaker && matchesDuration && matchesDate) {
			parentLi.style.display = "block";
			hasResults = true;  
		} else {
			parentLi.style.display = "none";
		}
	});

	// Show/hide no results message based on results
	if (hasResults) {
		noResultsMessage.style.display = "none";
		feedbackContainer.style.display = "block"
	} else {
		noResultsMessage.style.display = "block";
		feedbackContainer.style.display = "none";
	}
}

// date filtering
function isWithinWeek(date) {
	const today = new Date();
	const startOfWeek = new Date(today.getFullYear(), today.getMonth(), today.getDate() - today.getDay());
	const endOfWeek = new Date(startOfWeek.getTime() + 6 * 24 * 60 * 60 * 1000); // 6 days * 24 hours * 60 minutes * 60 seconds * 1000 milliseconds
	return date >= startOfWeek && date <= endOfWeek;
}

function isWithinMonth(date) {
	const today = new Date();
	return date.getMonth() === today.getMonth() && date.getFullYear() === today.getFullYear();
}

function isWithinLastMonth(date) {
	const today = new Date();
	const lastMonth = today.getMonth() - 1;
	const lastMonthYear = today.getMonth() === 0 ? today.getFullYear() - 1 : today.getFullYear();
	return date.getMonth() === lastMonth && date.getFullYear() === lastMonthYear;
}

function isWithinYear(date, year) {
	return date.getFullYear() === year;
}

// Add event listeners to all checkboxes
categoryCheckboxes.forEach((checkbox) => {
	checkbox.addEventListener("change", filterPodcasts);
});
speakerCheckboxes.forEach((checkbox) => {
	checkbox.addEventListener("change", filterPodcasts);
});
durationCheckboxes.forEach((checkbox) => {
	checkbox.addEventListener("change", filterPodcasts);
});
dateCheckboxes.forEach((checkbox) => {
	checkbox.addEventListener("change", filterPodcasts);
});

noResultsMessage.style.display = "none";

// Clear all filters in one go
const clearFiltersButton = document.getElementById("clear-filters");

clearFiltersButton.addEventListener("click", () => {
	const allCheckboxes = document.querySelectorAll('input[type="checkbox"]');

	allCheckboxes.forEach((checkbox) => {
		checkbox.checked = false;
	});

	podcastItems.forEach((item) => {
		const parentLi = item.closest("li");
		parentLi.style.display = "block"; // Show all items again
	});

	noResultsMessage.style.display = "none";
});
